import App from "./App.jsx";
import store from "./store/index";
import { persistedStore } from "./store/index";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import "./assets/css/style.scss";
import { SocketProvider } from "./Context/socketContext.jsx";
import { MarketWatchProvider } from "./Context/MarketWatchContext.jsx";

// Create a new QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0, // remove cache immediately after unused
      staleTime: 0,
      refetchOnWindowFocus: false, // Optional: Prevent refetching on window focus
      keepPreviousData: false,
    },
  },
});

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.debug = () => {};
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <QueryClientProvider client={queryClient}>
          <SocketProvider>
            <MarketWatchProvider>
              <App />
              <Toaster
                position="top-center"
                toastOptions={{
                  className: "rht_toaster",
                  duration: 3000,
                  style: {
                    background: "var(--font_default_color)",
                    color: "var(--font_defaultWhite_color)",
                    border: "1px solid var(--font_lists_gray_color)",
                  },
                  success: {
                    iconTheme: {
                      primary: "var(--gree_color)",
                      secondary: "var(--white-color)",
                    },
                  },
                  error: {
                    iconTheme: {
                      primary: "var(--red-color)",
                      secondary: "var(--white-color)",
                    },
                  },
                }}
              />
            </MarketWatchProvider>
          </SocketProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);
